import { useEffect, useMemo, useState } from 'react';
import Input from '../../components/form-components/Input';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { API_PATH } from '../../App';

const EditCategory = () => {
  const navigate = useNavigate();
  const defaultState = useMemo(
    () => ({
      isLoaded: false,
      error: null,
      category: {
        id: 0,
        category_name: '',
      },
    }),
    []
  );
  const [state, setState] = useState({ ...defaultState });
  const { id } = useParams();

  useEffect(() => {
    if (id !== '0') {
      try {
        fetch(`${API_PATH}v1/admin/categories/${id}`)
          .then((response) => {
            if (response.status !== 200) {
              let err = Error;
              err.Message = 'Invalid response code ' + response.status;
              setState((prevState) => ({ ...prevState, error: err }));
              return null;
            }
            return response.json();
          })
          .then((json) => {
            if (json == null) {
              return;
            }
            setState({
              ...defaultState,
              category: {
                id: Number(id),
                category_name: json.category.category_name,
              },
              error: null,
              isLoaded: true,
            });
          });
      } catch (err) {
        console.log(err);
      }
    } else {
      setState({
        ...defaultState,
        category: {
          id: 0,
          category_name: '',
        },
        isLoaded: true,
      });
    }
  }, [id, defaultState]);

  const onDeleteClick = () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    try {
      fetch(`${API_PATH}v1/admin/deleteCategory/${id}`, {
        method: 'GET',
        headders: myHeaders,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            console.log(data.error);
          } else {
            navigate('/admin-category');
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    // handle validation --> Duplicate

    const categoryToUpdate = {
      id: category.id,
      category_name: category.category_name,
    };

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    // Append JWT
    const requestOption = {
      method: 'POST',
      body: JSON.stringify(categoryToUpdate),
      headers: myHeaders,
    };

    fetch(`${API_PATH}v1/admin/updateCategory`, requestOption)
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          setState((prevState) => ({ ...prevState, error: data.error }));
        } else {
          navigate('/admin-category');
        }
      });
  };

  const { error, isLoaded, category } = state;
  if (error) return <div>error...</div>;
  if (!isLoaded) return <div>Loading...</div>;
  return (
    <div className="mx-auto max-w-3xl px-4 py-5 sm:p-6">
      <h2 className="text-2xl font-semibold">Add/Edit Category</h2>
      <hr className="mb-2" />
      <form onSubmit={handleSubmit}>
        <Input
          type={'text'}
          title={'Category'}
          name={'name'}
          value={category.category_name}
          handleChange={(e) => {
            setState((prev) => ({
              ...prev,
              category: { ...category, category_name: e.target.value },
            }));
          }}
        ></Input>

        <hr className="mb-2" />

        <button className="btn btn-primary">Save</button>
        <Link to="/admin-category" className="btn btn-warning ms-1">
          Cancel
        </Link>
        {category.id > 0 && (
          <a
            className="btn btn-danger ms-1"
            href="#!"
            onClick={() => onDeleteClick()}
          >
            Delete
          </a>
        )}
      </form>
    </div>
  );
};

export default EditCategory;
